import "./auth.ddc1a2e5.js";
import "./index.esm.8590e7b5.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9816"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9816"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $7iEdO = parcelRequire("7iEdO");

var $bMZn5 = parcelRequire("bMZn5");
// Sanitise the ?return= param — must be a relative path, no open-redirect
const $27435ee7e70aa165$var$rawReturn = new URLSearchParams(window.location.search).get('return') || '';
const $27435ee7e70aa165$var$returnUrl = $27435ee7e70aa165$var$rawReturn.startsWith('/') && !$27435ee7e70aa165$var$rawReturn.startsWith('//') ? $27435ee7e70aa165$var$rawReturn : '/studio';
// Redirect to the return URL (or /app) if already signed in
(0, $bMZn5.redirectIfAuth)($27435ee7e70aa165$var$returnUrl);
(0, $7iEdO.Analytics).trackPageView('login');
// --- Tab switching ---
const $27435ee7e70aa165$var$tabLogin = document.getElementById('tab-login');
const $27435ee7e70aa165$var$tabRegister = document.getElementById('tab-register');
const $27435ee7e70aa165$var$loginForm = document.getElementById('login-form');
const $27435ee7e70aa165$var$registerForm = document.getElementById('register-form');
function $27435ee7e70aa165$var$showTab(tab) {
    if (tab === 'login') {
        $27435ee7e70aa165$var$tabLogin.classList.add('text-indigo-600', 'border-indigo-600');
        $27435ee7e70aa165$var$tabLogin.classList.remove('text-gray-400', 'border-transparent');
        $27435ee7e70aa165$var$tabRegister.classList.remove('text-indigo-600', 'border-indigo-600');
        $27435ee7e70aa165$var$tabRegister.classList.add('text-gray-400', 'border-transparent');
        $27435ee7e70aa165$var$loginForm.classList.remove('hidden');
        $27435ee7e70aa165$var$registerForm.classList.add('hidden');
    } else {
        $27435ee7e70aa165$var$tabRegister.classList.add('text-indigo-600', 'border-indigo-600');
        $27435ee7e70aa165$var$tabRegister.classList.remove('text-gray-400', 'border-transparent');
        $27435ee7e70aa165$var$tabLogin.classList.remove('text-indigo-600', 'border-indigo-600');
        $27435ee7e70aa165$var$tabLogin.classList.add('text-gray-400', 'border-transparent');
        $27435ee7e70aa165$var$registerForm.classList.remove('hidden');
        $27435ee7e70aa165$var$loginForm.classList.add('hidden');
    }
    $27435ee7e70aa165$var$clearError();
}
$27435ee7e70aa165$var$tabLogin.addEventListener('click', ()=>$27435ee7e70aa165$var$showTab('login'));
$27435ee7e70aa165$var$tabRegister.addEventListener('click', ()=>$27435ee7e70aa165$var$showTab('register'));
// Open register tab if URL has #register
if (window.location.hash === '#register') $27435ee7e70aa165$var$showTab('register');
// --- Error display ---
const $27435ee7e70aa165$var$resendBtn = document.getElementById('btn-resend-verify');
function $27435ee7e70aa165$var$showError(msg, showResend = false) {
    const el = document.getElementById('auth-error');
    el.textContent = msg;
    el.className = 'mb-3 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700';
    $27435ee7e70aa165$var$resendBtn.classList.toggle('hidden', !showResend);
}
function $27435ee7e70aa165$var$showSuccess(msg) {
    const el = document.getElementById('auth-error');
    el.textContent = msg;
    el.className = 'mb-5 p-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700';
    $27435ee7e70aa165$var$resendBtn.classList.add('hidden');
}
function $27435ee7e70aa165$var$clearError() {
    const el = document.getElementById('auth-error');
    el.textContent = '';
    el.className = 'hidden';
    $27435ee7e70aa165$var$resendBtn.classList.add('hidden');
}
function $27435ee7e70aa165$var$setLoading(btnId, isLoading, label) {
    const btn = document.getElementById(btnId);
    btn.disabled = isLoading;
    btn.textContent = isLoading ? "Please wait\u2026" : label;
}
// --- Login ---
$27435ee7e70aa165$var$loginForm.addEventListener('submit', async (e)=>{
    e.preventDefault();
    $27435ee7e70aa165$var$clearError();
    const email = document.getElementById('login-email').value.trim();
    const password = document.getElementById('login-password').value;
    $27435ee7e70aa165$var$setLoading('btn-login', true, 'Sign in');
    try {
        await (0, $bMZn5.loginWithEmail)(email, password);
        // Also consume any pending return URL saved during registration
        const pending = localStorage.getItem('pendingReturnUrl');
        localStorage.removeItem('pendingReturnUrl');
        window.location.href = pending || $27435ee7e70aa165$var$returnUrl;
    } catch (err) {
        $27435ee7e70aa165$var$showError((0, $bMZn5.getAuthError)(err.code), err.code === 'auth/email-not-verified');
        $27435ee7e70aa165$var$setLoading('btn-login', false, 'Sign in');
    }
});
// --- Register ---
$27435ee7e70aa165$var$registerForm.addEventListener('submit', async (e)=>{
    e.preventDefault();
    $27435ee7e70aa165$var$clearError();
    const name = document.getElementById('register-name').value.trim();
    const email = document.getElementById('register-email').value.trim();
    const password = document.getElementById('register-password').value;
    if (!name) {
        $27435ee7e70aa165$var$showError('Please enter your name.');
        return;
    }
    $27435ee7e70aa165$var$setLoading('btn-register', true, 'Create account');
    try {
        await (0, $bMZn5.registerWithEmail)(email, password, name);
        // Save return URL so it survives the email verification detour
        if ($27435ee7e70aa165$var$returnUrl !== '/app') localStorage.setItem('pendingReturnUrl', $27435ee7e70aa165$var$returnUrl);
        $27435ee7e70aa165$var$showSuccess('Account created! Check your inbox (and spam folder) for a verification link before signing in.');
        $27435ee7e70aa165$var$setLoading('btn-register', false, 'Create account');
        $27435ee7e70aa165$var$registerForm.reset();
    } catch (err) {
        $27435ee7e70aa165$var$showError((0, $bMZn5.getAuthError)(err.code));
        $27435ee7e70aa165$var$setLoading('btn-register', false, 'Create account');
    }
});
// --- Resend verification ---
$27435ee7e70aa165$var$resendBtn.addEventListener('click', async ()=>{
    const email = document.getElementById('login-email').value.trim();
    const password = document.getElementById('login-password').value;
    $27435ee7e70aa165$var$resendBtn.disabled = true;
    $27435ee7e70aa165$var$resendBtn.textContent = "Sending\u2026";
    try {
        await (0, $bMZn5.resendVerificationEmail)(email, password);
        $27435ee7e70aa165$var$showSuccess('Verification email resent! Check your inbox (and spam folder).');
    } catch (err) {
        $27435ee7e70aa165$var$showError((0, $bMZn5.getAuthError)(err.code), true);
    }
    $27435ee7e70aa165$var$resendBtn.disabled = false;
    $27435ee7e70aa165$var$resendBtn.textContent = 'Resend verification email';
});
// --- Google ---
document.getElementById('btn-google').addEventListener('click', async ()=>{
    $27435ee7e70aa165$var$clearError();
    try {
        await (0, $bMZn5.loginWithGoogle)();
        const pending = localStorage.getItem('pendingReturnUrl');
        localStorage.removeItem('pendingReturnUrl');
        window.location.href = pending || $27435ee7e70aa165$var$returnUrl;
    } catch (err) {
        $27435ee7e70aa165$var$showError((0, $bMZn5.getAuthError)(err.code));
    }
});
document.getElementById('btn-reset-password').addEventListener('click', async ()=>{
    $27435ee7e70aa165$var$clearError();
    const email = document.getElementById('login-email').value.trim();
    if (!email) {
        $27435ee7e70aa165$var$showError('Enter your email first, then choose Reset password.');
        return;
    }
    try {
        await (0, $bMZn5.resetPassword)(email);
        $27435ee7e70aa165$var$showSuccess('Password reset email sent. Check your inbox and spam folder.');
    } catch (err) {
        $27435ee7e70aa165$var$showError((0, $bMZn5.getAuthError)(err.code));
    }
});


//# sourceMappingURL=login.760cf123.js.map
